import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from './cn';

/**
 * Прапорець на Radix. Нативний `<input type="checkbox">` малює операційна
 * система: у Safari він синій незалежно від теми, у Windows квадратний,
 * і жоден із них не знає наших токенів. Тут той самий фокус і клавіатура,
 * але вигляд наш.
 */
export function Checkbox({
	checked,
	onCheckedChange,
	className,
	ariaLabel,
	id,
	invalid,
}: {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	className?: string;
	ariaLabel?: string;
	/** Для звʼязку з `<label htmlFor>` у формах. */
	id?: string;
	/** Помилка валідації: межа стає червоною, як у полів вводу. */
	invalid?: boolean;
}): ReactNode {
	return (
		<RadixCheckbox.Root
			id={id}
			checked={checked}
			onCheckedChange={(next) => onCheckedChange(next === true)}
			aria-label={ariaLabel}
			aria-invalid={invalid || undefined}
			className={cn(
				'grid size-4 shrink-0 place-items-center rounded border transition-colors',
				'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
				checked ? 'border-primary-solid bg-primary-solid text-primary-fg' : 'bg-surface hover:border-fg-subtle',
				!checked && (invalid ? 'border-danger' : 'border-border-strong'),
				className,
			)}
		>
			<RadixCheckbox.Indicator>
				<Check className="size-3" strokeWidth={3} />
			</RadixCheckbox.Indicator>
		</RadixCheckbox.Root>
	);
}
